import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientAppointmentModel } from "@/Patient/Models/UI/Appointment/IPatientAppointmentModel";
import { ServiceTabSearch } from "./ServiceTabSearch";

interface IServiceFinder {
    Model: IPatientAppointmentModel;
}

class ServiceFinder extends React.Component<IServiceFinder, any> {
    public constructor(props: IServiceFinder) {
        super(props);
    }

    public render(): JSX.Element {
        var tabAcss = "tab";
        var tabBcss = "tab";

        if (this.props.Model.get("IsClinicianFilterTab") === true)
            tabAcss += " open";
        else
            tabBcss += " open rb";

        return (
            <div className="" onClick={e => e.stopPropagation()}>
                <div className="" style={{ height: "465px" }}>
                    <div className="widget-container round-corners-3 for-tabs">
                        <div className="header">
                            <label>{cacheStore.GetString("AppointmentMLabel")}</label>
                        </div>
                        <div className="main-container">
                            <div className="tb tabs-container">
                                <div className="tbc t1"><div className={tabAcss}><span onClick={this.setActiveTab.bind(this, "doctor")}>{cacheStore.GetString("AvailabilitySearchByDoctorTabName")}</span></div></div>
                                <div className="tbc t2"><div className={tabBcss}><span onClick={this.setActiveTab.bind(this, "service")}>{cacheStore.GetString("AvailabilitySearchByServiceTabName")}</span></div></div>
                            </div>
                            {this.clinicianFilterTab()}
                        </div>
                        <div className="btns-row clearfix">
                            <div className="pull-right">
                                <button className="btn btn-default push-right-5" onClick={this.close.bind(this)}><span>{cacheStore.GetString("CancelLabel")}</span></button>
                                <button className="btn btn-primary" onClick={this.onOkClick.bind(this)}><span>{cacheStore.GetString("OKLabel")}</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    private clinicianFilterTab(): JSX.Element {
        return (
            <div className="tab-content">
                <ServiceTabSearch Model={this.props.Model} />
            </div>
        );
    }

    private close(): void {
        // In its own timeout because this will umount the current component that launched this dispatch
        window.setTimeout(() => {
            LocalEvent.Dispatch(LocalPatientOperations.Appointment.HideServiceFinder);
        }, 50);
    }

    private onOkClick(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Appointment.OnOkClick);
    }

    private setActiveTab(tab: string): void {
        if (tab === "service") { LocalEvent.Dispatch(LocalPatientOperations.Appointment.ChangeTabToService); }
        else { LocalEvent.Dispatch(LocalPatientOperations.Appointment.ChangeTabToStaff); }
    }
}

export { ServiceFinder };
